import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { getCompany } from 'helper/user';
import { fetchAddress } from 'helper/address-search';
import AddressField from 'components/v2/address-field/address-field';
import InputField from 'components/v2/input-field/input-field';
import styles from './address-search-field.less';

const localeKeyPrefix = 'shopify.settings.addressSettingsSection.form';

const AddressSearchField = ({
  id,
  form,
  initialValue,
  onSelectAddress,
  userInfo,
  ...other
}) => {
  const [errorMessage, setErrorMessage] = React.useState(null);

  const { keywords = '', address = '' } = initialValue || {};

  const fetchAddressHandler = () => {
    const company = getCompany(userInfo);
    const countryCode = company ? company.countryCode : '';
    return keyword =>
      fetchAddress(keyword, null, company, {
        // lat: shippingAddress.latitude,
        // lng: shippingAddress.longitude,
        countryCode,
        isToggle: true,
      });
  };

  const updateHiddenAddressInputField = grabPoi => {
    form.setFieldsValue({
      [id]: JSON.stringify(grabPoi),
    });
  };

  const validateHiddenAddressInputField = () => {
    form.validateFields([id]);
  };

  const selectAddressHandler = (_, addressEntity) => {
    const grabPoi = {
      poiID: _get(addressEntity, 'id'),
      latlng: _get(addressEntity, 'latlng'),
      keywords: _get(addressEntity, ['address', 'name']),
      address: _get(addressEntity, ['address', 'combined_address']),
      country: _get(addressEntity, ['address', 'country']),
      countryID: _get(addressEntity, ['address', 'country_id']),
      city: _get(addressEntity, ['address', 'city']),
      cityID: _get(addressEntity, ['address', 'cityId']),
    };

    updateHiddenAddressInputField(grabPoi);
    validateHiddenAddressInputField();

    // update external source (map)
    onSelectAddress(grabPoi);
  };

  React.useEffect(() => {
    validateHiddenAddressInputField();
  }, []);

  return (
    <div>
      <AddressField
        initialValue={{ keywords, address }}
        fetchAddressFunc={fetchAddressHandler()}
        placeholder={`${I18n.t(`${localeKeyPrefix}.placeholder.address`)}*`}
        onSelectAddress={selectAddressHandler}
        showNumbers={false}
        enableDelete={false}
        isPickupAddress
      />
      {errorMessage && (
        <div className={styles.ErrorMessage}>{errorMessage}</div>
      )}
      <InputField
        {...other}
        id={id}
        fieldClassName={styles.Hidden}
        placeholder={'Sender address*'}
        fieldOptions={{
          initialValue: initialValue ? JSON.stringify(initialValue) : undefined,
          rules: [
            {
              required: true,
              message: I18n.t(`${localeKeyPrefix}.validation.addressRequired`),
            },
            {
              validator: (rule, value, cb) => {
                const grabPoi = JSON.parse(value);
                if (!grabPoi) {
                  const msg = I18n.t(
                    `${localeKeyPrefix}.validation.addressRequired`,
                  );
                  setErrorMessage(msg);
                  cb(msg);
                  return;
                }

                if (
                  !grabPoi.poiID ||
                  !(grabPoi.latlng || grabPoi.coordinates)
                ) {
                  const msg = I18n.t(
                    `${localeKeyPrefix}.validation.addressInvalid`,
                  );
                  setErrorMessage(msg);
                  cb(msg);
                  return;
                }

                setErrorMessage(null);
                cb();
              },
            },
          ],
        }}
        hidden
        disabled
        form={form}
      />
    </div>
  );
};

AddressSearchField.propTypes = {
  id: PropTypes.string.isRequired,
  form: PropTypes.shape({}).isRequired,
  userInfo: PropTypes.shape({}).isRequired,
  onSelectAddress: PropTypes.func.isRequired,
  initialValue: PropTypes.shape({}),
};

AddressSearchField.defaultProps = {
  initialValue: {
    keywords: '',
    address: '',
  },
};

export default AddressSearchField;
